(function($) {
    $.fn.iframeLazyLoad = function() {
        this.each(function() {
            var $iframe = $(this),
                iframeSource = $iframe.attr('data-src'),
                iframeSrcSet = false,

                updateIframeSrc = $.debounce(function() {
                    var distanceFromTopOfIframeToTopOfWindow = $iframe.offset().top - $(window).scrollTop(),
                        differenceBetweenHeightOfWindowAndDistanceFromTopOfIframeToTopOfWindow = window.innerHeight - distanceFromTopOfIframeToTopOfWindow,
                        sumOfWindowHeightPlusIframeHeight = distanceFromTopOfIframeToTopOfWindow + $iframe.height();

                    if (!iframeSrcSet && differenceBetweenHeightOfWindowAndDistanceFromTopOfIframeToTopOfWindow >= 0 && sumOfWindowHeightPlusIframeHeight >= 0) {
                        $iframe.attr('src', iframeSource);
                        $iframe.removeAttr('data-src');
                        iframeSrcSet = true;
                    }
                }, 250);

            window.addEventListener('scroll', updateIframeSrc);
        });
        return this;
    };
}(jQuery));
